import React from "react";
import Select from "react-select";

export const SimpleSelect = ({
	onChange,
	options,
	isMulti,
	value,
	classes,
	closeMenuOnSelect,
	disabled,
	placeholder,
	isSearchable,
	maxMenuHeight,
}) => {
	const c = classes || "";

	return (
		<Select
			className={`${c}`}
			closeMenuOnSelect={closeMenuOnSelect == null ? true : closeMenuOnSelect}
			value={value}
			isMulti={isMulti}
			options={options}
			onChange={onChange}
			isDisabled={disabled}
			placeholder={placeholder || "Select..."}
			isSearchable={isSearchable ? true : false}
			menuPlacement="auto"
		/>
	);
};
